<template>
    <div>
        <div
            id="main-wrapper"
            data-navbarbg="skin6"
            data-theme="light"
            data-layout="vertical"
            data-sidebartype="full"
            data-boxed-layout="full"
        >
            <header-principal></header-principal>
            <div v-if="accessDimenu">
                <Aside-principal @activarLateral="showAside = $event"></Aside-principal>
                <div class="page-wrapper" v-bind:class="{ show: showAside }">
                    <router-view></router-view>
                </div>
            </div>
            <div v-else style="margin-top: 60px"><Loader></Loader></div>
            <footer-principal></footer-principal>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import HeaderPrincipal from "@/views/Header";
import AsidePrincipal from "@/views/dimenu/AsideDimenu";
import FooterPrincipal from "@/views/Footer";
import Loader from "@/components/shared/Loader";
export default {
    name: "DimenuLayout",
    components: {
        HeaderPrincipal,
        AsidePrincipal,
        FooterPrincipal,
        Loader,
    },
    data () {
        return {
            showAside: false,
        }
    },
    created () {
        if (this.$store.getters.loggedIn) {
            // console.log('si hay login M');
            let org = localStorage.getItem("mark_client_data");
            window.master
                .get("getapp/" + org)
                .then((response) => {
                    let r = response.data.r; // listado de app disponibles
                    let AppDimenu = false;
                    if (r.length > 0) {
                        for (let i in r) {
                            if (r[i].id == localStorage.getItem("appIDactual")) {
                                AppDimenu = true;
                            }
                        }
                    }
                    if (AppDimenu) {
                        //si tiene Dimenus asignado entonces permitir acceso
                        const accessDimenu = {
                            login: true,
                            token: null,
                        };
                        this.$store.dispatch("getCurrency");
                        this.$store.dispatch("access_Dimenu", accessDimenu);
                    } else {
                        const accessDimenu = {
                            login: false,
                            token: false,
                        };
                        this.$store.dispatch("access_Dimenu", accessDimenu);
                        this.$router.push({ name: "Home" });
                    } //sino volver a home
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            this.$router.push({ name: "Home" });
        }
    },
    computed: {
        ...mapGetters({ accessDimenu: "access_Dimenu" }),
    },
}
</script>
<style scoped lang="scss">
.header {
    top: 0;
}
.page-wrapper {
    margin-left: 170px;
}
#main-wrapper[data-layout="vertical"][data-sidebartype="full"] .page-wrapper {
    margin-left: 100px;
}
</style>
